export default {
  v3OfficialTopUpCenterTitle: 'Centre de Recharge Officiel',
  v3OfficialTopUpCenterKeyword: 'Centre de Recharge Officiel',
  v3OfficialTopUpCenterDescription: 'Centre de Recharge Officiel',
  v3SafeAndFast: 'Sûr, Sans Risque et Immédiatement Crédité',
  v3Shop: 'Centre commercial',
  v3ShoppingCart: "Panier d'Achat",
  v3MembershipCenter: 'Centre de Privilège (Centre des Membres Premium)',
  v3Login: 'Connexion',
  v3Account: 'Compte',
  v3EnterAccountName: 'Entrer le Nom du Compte',
  v3Password: 'Mot de passe',
  v3EnterPassword: 'Entrer le Mot de Passe',
  v3ForgotPassword: 'Mot de passe Oublié',
  v3EnterUID: "Entrer l'UID",
  v3OTP: 'OTP',
  v3EnterOTP: "Veuillez saisir l'OTP",
  v3SelectTopUpCharacter: 'Sélectionner le personnage de la recharge',
  v3SelectServer: 'Sélectionner un Serveur',
  v3Confirm: 'Confirmer',
  v3CharacterNotFound:
    "Si vous ne trouvez pas le personnage, essayez d'abord de vous connecter au personnage dans le jeu, puis connectez-vous à la page de rechargement ou contactez le service clientèle.",
  v3Logout: 'Se déconnecter',
  v3SwitchAccount: 'Changer de Compte',
  v3MyCoupons: 'Mes Coupons',
  v3BenefitsCenter: 'Centre de Privilèges',
  v3TopUpBenefits: 'Avantages de Recharge',
  v3MoreSettings: 'Plus de Paramètres',
  v3RememberLoginStatus: 'Se souvenir de mon statut de connexion',
  v3OrderQuery: 'Vérifier les Commandes',
  v3ContactCustomerService: 'Service Clientèle',
  v3LoginWithApp: "Se Connecter via l'Application",
  v3ChooseOtherLoginMethod: 'Sélectionner une autre méthode de connexion',
  v3ConnectingToGameApp: "Se connecter à l'application du jeu",
  v3EnsureGameInstalled:
    "Veuillez vous assurer que le jeu est installé sur cet appareil. Si le jeu ne répond pas ou si la connexion échoue, mettez à jour le jeu avec la dernière version disponible sur l'app store ou changez de navigateur.",
  v3OpenGame: 'Lancer le Jeu',
  v3DownloadGame: 'Télécharger le Jeu',
  v3UpdateGameIfOpenFails:
    "Si le jeu ne se lance pas, mettez-le à jour avec la dernière version de l'App Store/Google Play.",
  v3ClickToDownloadLatestVersion:
    'Vous pouvez également cliquer sur le bouton Télécharger le jeu pour obtenir la dernière version.',
  v3LoggingIntoOfficialTopUpCenter:
    'Vous vous connectez au [Centre de Recharge Officiel]',
  v3CurrentAccount: 'Compte actuel : xxxxxxxxxx',
  v3WelcomeToOfficialTopUpCenter: 'Bienvenue au Centre de Recharge Officiel',
  v3OfficialAuthorizedLogin:
    'Connexion officiellement autorisée. Aucun risque de sécurité.',
  v3TermsOfService: "Conditions d'Utilisation",
  v3PrivacyPolicy: 'Politique de Confidentialité',
  v3ThirdPartySocialAccountDescription:
    "À propos du compte de média social d'un tiers",
  v3BindSocialAccountInGameFirst:
    "Veuillez d'abord procéder à l'activation de votre compte de réseau social dans le centre d'utilisateurs du jeu, puis connectez-vous avec le compte de média social activé.",
  v3FirstTopUp15PercentOff:
    "Bénéficiez d'une réduction de 15% sur votre première recharge",
  v3MoreTopUpRebates: 'Plus de réductions et de récompenses sur les recharges',
  v3LoginToViewOffers: 'Se connecter pour voir les réductions',
  v3TopUpEnvironmentChecking: "Vérifier l'environnement de recharge...",
  v3SafeToUse: 'Sûr et sécurisé.',
  v3LimitedTimeBenefits: 'Offre exclusive en temps limité',
  v3EventRules: "Règles de l'Événement",
  v3MoreEvents: "Plus d'événements",
  v3Claim: 'Réclamer',
  v3Completed: 'Terminé',
  v3GoTo: 'Aller',
  v3ViewDetails: 'Voir les Détails',
  v3RecommendedProducts: 'Objets Recommandés',
  v3SearchProductName: "Recherche par nom d'objet",
  v3AllCategories: 'Tout',
  v3PopularSort: 'Top',
  v3PriceAscending: 'Prix ↑',
  v3PriceDescending: 'Prix ↓',
  v3DiamondBonus10Percent: 'Diamant +10%',
  v3YuanbaoBonus10Percent: 'Lingot +10%',
  v3ExtraBonus10Percent: 'Bonus : 10%',
  v3FirstTopUpDouble: '1ère Recharge Doublée',
  v3FirstExtraBonus: 'Bonus de 1ère Fois',
  v3ProductDetails: 'Détails du Produit',
  v3AddToCart: 'Ajouter au Panier',
  v3AddedToCart: 'Ajouté au Panier',
  v3BuyNow: 'Acheter Maintenant',
  v3NoItemsInCart: 'Aucun objet dans votre panier pour le moment',
  v3SelectedItemsN: 'Objets sélectionnés : (${n})',
  v3RemoveFromCart: 'Retirer du panier ?',
  v3Yes: 'Oui',
  v3No: 'Non',
  v3LimitOnePerPurchase:
    "Cet article ne peut être acheté qu'une seule fois à la fois",
  v3ItemPrice: "Prix de l'Objet",
  v3Tax: 'Taxe',
  v3ExtraGift: 'Bonus',
  v3Total: 'Total',
  v3ProceedToPayment: 'Payer',
  v3SelectCoupon: 'Sélectionner un Coupon',
  v3UnavailableCoupons: 'Coupons Inutilisables',
  v3OneCouponPerOrder: 'Un coupon par commande',
  v3DiscountCoupon: 'Coupon de Réduction',
  v3ThresholdCoupon: 'Coupon de Déduction',
  v3MinSpendCoupon: 'Utilisable lorsque le prix total est supérieur à xx USD',
  v3MaxDiscountCoupon: "Réduction jusqu'à xxxx USD",
  v3LimitedChannel: 'Limité à des canaux spécifiques',
  v3AllChannels: 'Disponible pour tous les canaux',
  v3SpecificProducts: 'Objets spécifiques uniquement',
  v3AllProducts: 'Pour tous les objets',
  v3NotYetTimeToUse: 'Pas encore utilisable',
  v3Expired: 'Expiré',
  v3Used: 'Utilisé',
  v3ValidityPeriod: 'Validité : ',
  v3ConfirmUse: 'Confirmer',
  v3ChangeProduct: "Modifier l'objet",
  v3ConfirmPaymentOrder: 'Confirmer la Commande',
  v3StoredValueRole: 'Personnage de Recharge',
  v3TotalNProducts: 'Total des objets : ${n}',
  v3SelectPaymentMethod: 'Sélectionner le Mode de Paiement',
  v3PayNow: 'Payer Maintenant',
  v3MorePaymentMethods: 'Autres Modes de Paiement',
  v3NoAvailablePaymentMethodContactSupport:
    'Vous ne trouvez aucun mode de paiement disponible ? Contactez le Service Clientèle.',
  v3AvailableCoupons: 'Coupons Utilisables',
  v3Extra10Percent: '0.1',
  v3LastSelection: 'Choix Précédent',
  v3RecommendedUsage: 'Recommandé',
  v3PopularChoice: 'Choix Populaire',
  v3PaymentSuccess: 'Paiement Effectué',
  v3PaymentFailure: 'Paiement Échoué',
  v3TopUpFailureMessage:
    'Désolé, la recharge a échoué. Veuillez essayer de soumettre à nouveau votre commande ou contacter le service clientèle.',
  v3Game: 'Jeu',
  v3UID: 'UID',
  v3OrderNumber: 'N° de Commande',
  v3ProductContent: "Détails de l'Objet",
  v3ViewProductDetails: "Voir les Détails de l'Objet",
  v3PaymentMethod: 'Mode de Paiement',
  v3Complete: 'Complet',
  v3TopUpAgain: 'Recharger Encore',
  v3FriendlyReminderSaveOrderInfo:
    "Rappel : Sauvegardez les informations de votre commande par capture d'écran pour un traitement plus rapide.",
  v3RechargeAgain: 'Recharger Encore',
  v3TransactionInProgress: 'Traitement de la transaction',
  v3CompletePaymentInChannel:
    'Veuillez passer au canal de paiement pour effectuer le paiement.',
  v3RestAssuredFastDeliveryAfterPayment:
    "L'article vous sera envoyé dès réception du résultat du paiement.",
  v3SaveOrderInfoForProgress:
    "Vous pouvez faire une capture d'écran des informations relatives à la commande pour suivre l'évolution de la transaction.",
  v3PaymentCompleted: 'Le paiement a été effectué',
  v3AddToHomeScreen: "Ajouter à l'Écran d'Accueil",
  v3AddShortcutForBonus:
    'Ajouter un raccourci pour recevoir des récompenses supplémentaires',
  v3ShareSuccess: 'Partagé',
  v3ShareFailure: 'Échec du partage',
  v3RewardClaimed: 'Récompense Réclamée',
  v3RewardClaimFailed: 'Échec de la réclamation de la récompense',
  v3EventNotStarted: "L'événement n'a pas encore commencé",
  v3EventEnded: "L'événement est terminé",
  v3ClickSelectCoupon: 'Cliquez pour sélectionner un coupon',
  v3CouponsRecommendedUsed: 'Coupon recommandé utilisé',
  v3CouponsSelected: 'Coupon sélectionné',
  v3NoCouponsAvaliable: 'Aucun coupon disponible',
  v3SupplementStatus: 'Statut',
  v3SupplementNormal: 'Normal',
  v3SupplementBanned: 'Banni',
  v3SupplementPendingPayment: 'Paiement en attente',
  v3SupplementSwitchCharacter: 'Changer de personnage',
  v3SupplementAccountInfoInvalid: 'Informations du compte invalides',
  v3SupplementContactGSForTopUpLink:
    'Veuillez contacter GS pour obtenir le lien de recharge',
  v3SupplementTopUpCompleted: 'Recharge terminée :',
  v3SupplementTotalRefundOrders: 'Total des commandes remboursées : {}',
  v3SupplementPendingSupplementAmount: 'Montant du paiement en attente :',
  v3SupplementAccountCharacterNormalNoPaymentNeeded:
    'Compte/personnage normal, aucun paiement nécessaire',
  v3SupplementEnjoyYourGame: 'Profitez de votre jeu !!',
  v3SupplementOrderInformation: 'Informations de commande',
  v3SupplementPendingPaymentAmount: 'Montant en attente de paiement :',
  v3LookUpCouponRule: 'Vérifier les règles de distribution des coupons',
  v3SwitchOldVersion: "Passer à l'Ancienne Plateforme de Paiement",
  v3FirstTopUpGiveaway: 'Bonus 1ère Recharge',
  v3SecureConnection: 'Connexion sécurisée en cours',
  v3RequestTimeOut: 'Expiration du délai, veuillez réessayer ultérieurement.',
  v3ConfirmLeave: `Quitter ?`,
  v3NoSubmitOrder: `Votre panier n'a pas encore été validé. Vous risquez de rater les objets souhaités si vous quittez.`,
  v3ContinueSubmit: 'Continuer',
  v3LeaveSubmit: 'Quitter',
  v3RecentBug: 'Achats récents',
  v3PwaTapShareOrMenuIcon: 'Appuyez sur l\'icône Partager ou Menu dans la barre d\'outils du navigateur',
  v3PwaFindAndTapAddToHomeScreen: 'Trouvez et appuyez sur « Sur l\'écran d\'accueil » dans les options'
};
